import wiredConfig from '../environments/config'
declare global {
    interface Window {
        ccConfig: any;
    }
}

interface ConfigProps {
    DOMAIN: string,
    REACT_APP_ACTIVE_MASTER_EVENTS_NODE_FIREBASE: string,
    REACT_APP_API_BASE_URL: string,
    REACT_APP_DEFAULT_CHANNELS_BACKGROUND_IMG_URL: string,
    REACT_APP_FB_API_KEY: string,
    REACT_APP_FB_AUTH_DOMAIN: string,
    REACT_APP_FB_DB_URL: string,
    REACT_APP_FB_FUNCTIONS_NOTIFICATIONS_HOST: string,
    REACT_APP_FB_PROJECT_ID: string,
    REACT_APP_HOST_PRIMARY: string,
    REACT_APP_MESSAGING_SENDER_ID: string,
    REACT_APP_PLATFORM: string,
    REACT_APP_PROXY_HOST: string,
    REACT_APP_PROXY_HOST_FOR_SETUP_PROXY: string,
    REACT_APP_STORAGE_BUCKET: string,
    SENTRY_DSN_WWW: string,
    SENTRY_ENV: string,
    AUTH_DOMAIN: string,
    AUTH_CLIENT_ID: string
    AUTH_AUD: string
}


const windowConfig: ConfigProps = window.ccConfig;

//If we are running in docker, we reference window config
const config = process.env['NODE_ENV'] === "development" ? wiredConfig : windowConfig;
export default config;